/* Naoko — LP „Black Friday VIP — Winda” (docs/lp-bf-vip-winda-plan.md): JS skórki naoko-bfw-*.
   Silnik zapisu, ?typ=1, filmu hero, wjazdu, kotwic i kopiowania to assets/naoko-vip.js; tu tylko:
   - panel pięter (naoko-bfw-floors): klik w piętro = wyświetlacz „jedzie” piętro po piętrze
     (420 ms na piętro, migająca strzałka), potem nazwa i opis piętra z data-* przycisku (teksty
     z Liquid, z twardymi spacjami); przypis o regulaminie przy piętrze z data-foot; numer leci też
     na wskaźnik w hero (makieta v2), przycisk VIP wpisuje tam swój napis,
   - (przypięcie wskaźnika piętra do filmu robi skrypt inline w naoko-bfw-hero — tu byłoby za późno),
   - drzwi windy (naoko-bfw-zapis): film ładowany przed wjazdem w ekran, po wjechaniu (45%) i 1 s
     sam „naciska” przycisk → film → `ended` = otwarte (od 1360 px formularz pojawia się w kabinie);
     zapas: błąd / brak odtwarzania / ograniczenie ruchu = plakat „otwarte”; bezpiecznik 9 s;
     po ?typ=1 od razu otwarte (D7).
   Dołączają go sekcje pięter i zapisu — blokada drugiego uruchomienia. */
(function () {
  if (window.NaokoBfw) return;
  window.NaokoBfw = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------- Panel pięter ---------------- */
  function initFloors(root) {
    if (root.dataset.bfwReady) return;
    root.dataset.bfwReady = '1';
    var keys = [].slice.call(root.querySelectorAll('.nbfw-key[data-i]'));
    var disp = root.querySelector('.nbfw-disp');
    var dA = root.querySelector('[data-bfw-ar]');
    var dN = root.querySelector('[data-bfw-n]');
    var dT = root.querySelector('[data-bfw-t]');
    var dM = root.querySelector('[data-bfw-desc]');
    var dF = root.querySelector('[data-bfw-foot]');
    if (!keys.length || !dN) return;
    var busy = null;
    /* wskaźnik w hero — szukany przy każdym kliknięciu (edytor przerysowuje sekcje osobno) */
    var setInd = function (t) {
      document.querySelectorAll('.nbfw-ind__fl').forEach(function (el) { el.textContent = t; });
    };
    var vip = root.querySelector('.nbfw-key--vip');
    if (vip) {
      vip.addEventListener('click', function () {
        clearTimeout(busy);
        if (disp) disp.classList.remove('is-moving');
        var l = vip.querySelector('span');
        setInd(l ? l.textContent.trim() : 'VIP');
      });
    }

    keys.forEach(function (k) {
      k.addEventListener('click', function () {
        var i = +k.dataset.i;
        keys.forEach(function (x) {
          var on = x === k;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        clearTimeout(busy);
        var n = +dN.textContent || 1;
        var to = i + 1;
        if (dA) dA.textContent = to >= n ? '▲' : '▼';
        if (disp) disp.classList.add('is-moving');
        if (dM) dM.style.opacity = 0.3;
        var step = function () {
          setInd(n);
          if (n === to) {
            if (disp) disp.classList.remove('is-moving');
            if (dT) dT.textContent = k.dataset.title || '';
            if (dM) { dM.textContent = k.dataset.text || ''; dM.style.opacity = 1; }
            if (dF) dF.hidden = k.dataset.foot !== '1';
            return;
          }
          n += n < to ? 1 : -1;
          dN.textContent = n;
          setInd(n);
          busy = setTimeout(step, 420);
        };
        if (n === to) step();
        else { if (dT) dT.textContent = ''; busy = setTimeout(step, 420); }
      });
    });
  }

  /* ---------------- Drzwi windy ---------------- */
  function initLift(root) {
    var lift = root.querySelector('.nbfw-lift');
    if (!lift || lift.dataset.bfwReady) return;
    lift.dataset.bfwReady = '1';
    var v = lift.querySelector('video');
    var call = lift.querySelector('.nbfw-call');
    var mob = window.matchMedia('(max-width: 760px)').matches;
    var pressed = false, loaded = false;

    function open() { lift.classList.add('is-open'); }
    function still() { lift.classList.remove('is-playing'); lift.classList.add('is-still'); open(); }
    function press() {
      if (pressed) return;
      pressed = true;
      if (call) call.classList.add('is-on');
      if (!v || reduced.matches) { setTimeout(still, 400); return; }
      load();
      var p = v.play();
      if (p && p.then) p.then(function () { lift.classList.add('is-playing'); }, still);
      else lift.classList.add('is-playing');
      setTimeout(open, 9000);
    }
    function load() {
      if (loaded || !v) return;
      loaded = true;
      var src = mob ? (v.dataset.srcM || v.dataset.srcD) : (v.dataset.srcD || v.dataset.srcM);
      if (!src) { still(); return; }
      v.muted = true;
      v.src = src;
      v.load();
    }

    /* po zapisie (strona wraca z ?typ=1): od razu otwarte, bez czekania na film */
    if (root.classList.contains('is-typ')) {
      pressed = true;
      if (call) call.classList.add('is-on');
      still();
      return;
    }
    if (v) {
      v.addEventListener('ended', open);
      v.addEventListener('error', still);
      v.addEventListener('playing', function () { lift.classList.add('is-playing'); });
    }
    if (call) call.addEventListener('click', press);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es, o) {
        if (es[0].isIntersecting) { o.disconnect(); if (!reduced.matches) load(); }
      }, { rootMargin: '800px 0px' }).observe(lift);
      new IntersectionObserver(function (es, o) {
        if (es[0].isIntersecting) { o.disconnect(); setTimeout(press, 1000); }
      }, { threshold: 0.45 }).observe(lift);
    } else {
      press();
    }
  }

  function init(scope) {
    var r = scope || document;
    r.querySelectorAll('.nbfw-floors').forEach(initFloors);
    r.querySelectorAll('.nbfw-zapis').forEach(initLift);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
